import BaseRepository from "./base-repository";

class PlayRepository extends BaseRepository {
    async getPlayWithFragments(id) {
        const [play] = await this.table
            .where({ id })
            .with({ fragments: "fragment" });

        play?.fragments?.sort(
            (a, b) => a.associatedHistoryIndex - b.associatedHistoryIndex
        );

        return play;
    }

    async getPlaysWithFragments(gameId) {
        const plays = await this.table
            .where({ gameId: gameId })
            .with({ fragments: "fragment" });

        plays
            .sort((a, b) => a.index - b.index)
            .forEach((play) => {
                play.fragments?.sort(
                    (a, b) =>
                        a.associatedHistoryIndex - b.associatedHistoryIndex
                );
            });

        return plays;
    }
}

export default PlayRepository;
